export default __webpack_public_path__ + "static/media/logotantra.a696588d.png";